










































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import { InformationTypeTree } from "@/common/models";
import FilesTableModalVue from "../files-table-modal/FilesTableModal.vue";
export default Vue.extend({
  components: {
    Modal,
  },
  /* tree of label_id,label_name, session_id */
  props: ["modalData"],
  setup(props, { emit }) {
    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      backdropDismiss: true,
      withTopRightCloseBtn: true,
      width: "60rem",
      height: "50rem",
    };

    const show_files_for_label = (label: InformationTypeTree) => {
      UseModal().show(FilesTableModalVue, {
        label_id: label.id,
        label_name: label.name,
        // @ts-ignore
        session_id: props.modalData.session_id,
      });
    };

    return {
      modal_config,
      show_files_for_label,
    };
  },
});
